import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Container,
  Grid,
  Paper,
  Divider
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleLogin = () => navigate("/login");
  const handleRegister = () => navigate("/register");
  const handleTryFree = () => navigate("/app");

  return (
    <Container maxWidth="xl" sx={{ py: 6 }}>
      {/* Header Section */}
      <Paper elevation={3} sx={{ p: 4, mb: 6, textAlign: "center", background: "#e3f2fd" }}>
        <Typography variant="h3" gutterBottom>
          🚀 Unlock the True ROI of Your PLM Investments
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
          Empower decision-makers with data-driven insights. Simulate. Fine-tune. Justify. Win.
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Button variant="contained" color="primary" sx={{ mx: 2 }} onClick={handleTryFree}>
            Try Free
          </Button>
          <Button variant="outlined" sx={{ mx: 2 }} onClick={handleLogin}>
            Login
          </Button>
          <Button variant="outlined" sx={{ mx: 2 }} onClick={handleRegister}>
            Register
          </Button>
        </Box>
      </Paper>

      {/* Key Benefits Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>✨ Why PLM ROI Interactive Engine?</Typography>
        <Grid container spacing={4}>
          {[
            "Quantify the value of your engineering complexity and supply chain efforts",
            "Simulate ROI by sliding real-world business levers",
            "Save scenarios by user, tier, industry — view what impacts value",
            "Export clear reports that win executive buy-in",
            "Map PLM features to business strategy with confidence"
          ].map((point, idx) => (
            <Grid key={idx} item xs={12} md={6}>
              <Box display="flex" alignItems="flex-start">
                <CheckCircleIcon color="primary" sx={{ mt: "3px", mr: 1 }} />
                <Typography variant="body1">{point}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Divider sx={{ mb: 4 }} />

      {/* Industry Proof Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>🏆 Trusted by Industry Experts</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Used by top manufacturers and system integrators in Automotive, Aerospace, Machinery, and Electronics to justify PLM spend and boost adoption.
        </Typography>
      </Box>

      {/* Footer CTA */}
      <Paper elevation={2} sx={{ p: 4, textAlign: "center", backgroundColor: "#f1f8e9" }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Ready to drive real business value with PLM?
        </Typography>
        <Button variant="contained" size="large" onClick={handleTryFree}>
          Start Free ROI Simulation
        </Button>
      </Paper>
    </Container>
  );
};

export default LandingPage;
